import { useQueryClient } from '@tanstack/react-query'
import { Modal, ModalProps } from 'antd'

import { usePersonsServiceGetPersonListByDataEndpointKey } from 'src/api/queries'
import { useLocales } from 'src/locales'

import { PersonalDataSearch } from './components'

type Props = {
  onAddClick?: (id: string) => void
  onCancel: () => void
  selectMode?: boolean
} & ModalProps

export const SearchPersonModal = ({
  onAddClick,
  onCancel,
  selectMode,
  ...props
}: Props) => {
  const { t } = useLocales()

  const queryClient = useQueryClient()

  const handleCancel = () => {
    queryClient.removeQueries({
      queryKey: [usePersonsServiceGetPersonListByDataEndpointKey],
      exact: false
    })
    onCancel()
  }

  return (
    <Modal
      open
      width={1000}
      maskClosable={false}
      title={t('persons.person_management')}
      centered
      footer={false}
      onCancel={handleCancel}
      styles={{
        body: {
          maxHeight: '70vh',
          overflowY: 'auto'
        }
      }}
      {...props}
    >
      <PersonalDataSearch
        onAddClick={onAddClick}
        onCancel={handleCancel}
        selectMode={selectMode}
      />
    </Modal>
  )
}
